import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {GlobalCacheConfig, LocalStorageStrategy} from 'ts-cacheable';

GlobalCacheConfig.storageStrategy = LocalStorageStrategy;
GlobalCacheConfig.maxAge = 60000; // 60 seconds
GlobalCacheConfig.slidingExpiration = true;
GlobalCacheConfig.maxCacheCount = 100;


if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).catch(err => {
  console.error('App Error:');
  console.error(err);
});
